import {PlayerDurum} from '@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes';

/**
 * İşlemler ekranındaki Başlat/Durdur düğmesi görünür mü? (DEV-2603, C6)
 *
 * UYAP bağlantısı yalnız BAŞLATMAK için gerekir: bağlantı yokken 'Başlat'ın bir işlevi yok.
 * Ama bot UYAP düşse de 'oto'da kalır (dongu artık player'ı 'dur' yapmıyor; botBaglantisiniSurdur
 * geri çekilmeyle yeniden girmeyi dener). Kullanıcı o bekleme sırasında botu durdurabilmeli;
 * 'durduruluyor' da görünür kalır ki düğme basıldığı anda yok olmasın, ilerleme çarkı görünsün.
 *
 * UYAP engeli (DEV-3572): kilit sürerken bağlı bayrağı false'a düşse bile Başlat görünür (kullanıcı onaylı Başlat ile
 * kilidi kaldırabilsin). Üçüncü parametre yoksa davranış eskisi gibidir.
 *
 * NOT: PlayerDurum.oto sayısal 0'dır; karşılaştırma her zaman açık yapılır (falsy tuzağı).
 */
export function baslatDurdurDugmesiGorunurMu(playerDurum: PlayerDurum, uyapBagli: boolean, engelVar = false): boolean {
    return uyapBagli || playerDurum !== PlayerDurum.dur || engelVar === true;
}
